export const DOC_FLOW_EDIT_SEQUENCE_MODAL_PERMANENT_NOTIFICATION_ID = 'info'
